import { render, staticRenderFns } from "./TaskOpenSubtasksModal.vue?vue&type=template&id=ce0c27dc&"
import script from "./TaskOpenSubtasksModal.vue?vue&type=script&lang=js&"
export * from "./TaskOpenSubtasksModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports